import React, { useState } from "react";

import styled from "styled-components";

import Button from "components/atoms/button";
import RadioButton from "components/atoms/input/RadioButton";
import Text from "components/atoms/text/Text";

import {
    InitialFieldBody,
    InitialFieldCard,
    InitialFieldChevron,
    InitialFieldHeader,
    InitialFieldPrompt,
    InitialFieldSummary,
    InlineInput,
    InlineInputRow,
    InputWrap,
    IntroDescription,
    OptionDescription,
    OptionTextWrap,
    PanelCard,
    QueryInput,
    QuestionOptionRow,
} from "components/organisms/report/styled";

import { genericEnterKeyDown } from "utils/validation";

const IntroText = styled(Text).attrs({
    variant: "body-md-400",
})``;

const ConditionText = styled(Text).attrs({
    variant: "body-md-400",
    margin: "40px 0px 0px 0px",
})``;

export default function RequestStepSection({
    ready,
    queryInput,
    onQueryInputChange,
    initialFields,
    initialSelections,
    initialCustomInputs,
    onSelectInitialOption,
    onChangeInitialCustomInput,
    onSubmitRequest,
    canSubmitRequest,
}) {
    const [expandedCategory, setExpandedCategory] = useState("");

    const toggleCategory = (category) => {
        setExpandedCategory((prev) => (prev === category ? "" : category));
    };

    return (
        <PanelCard>
            <IntroText>연구 주제</IntroText>
            <IntroDescription>연구 주제와 기본 조건을 입력하면 계획 단계를 시작합니다.</IntroDescription>
            <InputWrap>
                <QueryInput
                    value={queryInput}
                    onChange={(e) => onQueryInputChange(e.target.value)}
                    onKeyDown={(e) => {
                        genericEnterKeyDown(e, () => {
                            if (canSubmitRequest) {
                                onSubmitRequest();
                            }
                        });
                    }}
                    placeholder="에이전트가 검색할 연구 주제를 입력하세요."
                    disabled={!ready}
                />
                <Button
                    onlyText
                    width={"140px"}
                    height={"44px"}
                    size={"small"}
                    bgColor={"var(--color-Button1)"}
                    hoverBgColor={"var(--color-ButtonHover1)"}
                    fontColor={"var(--color-White)"}
                    buttonText={"계획 시작"}
                    onClick={onSubmitRequest}
                    disabled={!canSubmitRequest}
                />
            </InputWrap>

            <ConditionText>기본 조건</ConditionText>
            {initialFields.map((field) => {
                const selectedOptionId = initialSelections[field.category];
                const selectedOption =
                    field.options.find((option) => option.id === selectedOptionId) || field.options[0];
                const selectedSummaryDescription =
                    selectedOption?.id === "other"
                        ? (initialCustomInputs[field.category] || "").trim() || selectedOption?.description
                        : selectedOption?.description;
                const isExpanded = expandedCategory === field.category;
                return (
                    <InitialFieldCard key={field.category} collapsible expanded={isExpanded}>
                        <InitialFieldHeader
                            type="button"
                            onClick={() => toggleCategory(field.category)}
                            aria-expanded={isExpanded}
                            aria-controls={`initial-field-body-${field.category}`}
                        >
                            <div>
                                <InitialFieldPrompt>{field.prompt}</InitialFieldPrompt>
                                <InitialFieldSummary>
                                    {selectedOption?.label}
                                    {selectedSummaryDescription ? ` - ${selectedSummaryDescription}` : ""}
                                </InitialFieldSummary>
                            </div>
                            <InitialFieldChevron expanded={isExpanded}>⌄</InitialFieldChevron>
                        </InitialFieldHeader>

                        {isExpanded && (
                            <InitialFieldBody id={`initial-field-body-${field.category}`}>
                                <div>
                                    {field.options.map((option) => (
                                        <QuestionOptionRow key={`${field.category}-${option.id}`}>
                                            <RadioButton
                                                type="radio"
                                                name={`initial-${field.category}`}
                                                label={option.label}
                                                checked={selectedOptionId === option.id}
                                                onChange={() => {
                                                    onSelectInitialOption(field.category, option.id);
                                                    if (option.id !== "other") {
                                                        setExpandedCategory("");
                                                    }
                                                }}
                                                disabled={!ready}
                                            />
                                            <OptionTextWrap>
                                                <OptionDescription>{option.description}</OptionDescription>
                                            </OptionTextWrap>
                                        </QuestionOptionRow>
                                    ))}
                                </div>
                                {selectedOptionId === "other" && (
                                    <InlineInputRow>
                                        <InlineInput
                                            value={initialCustomInputs[field.category] || ""}
                                            onChange={(e) => onChangeInitialCustomInput(field.category, e.target.value)}
                                            placeholder={field.customPlaceholder}
                                            disabled={!ready}
                                        />
                                    </InlineInputRow>
                                )}
                            </InitialFieldBody>
                        )}
                    </InitialFieldCard>
                );
            })}
        </PanelCard>
    );
}
